var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarketLoginSelectorUk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6479_15659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4 0H28V24H-4V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.25 0L11.95 9.05L24.1 0H28V3.1L16 12.05L28 20.95V24H24L12 15.05L0.0499997 24H-4V21L7.95 12.1L-4 3.2V0H-0.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 14.05L28 22V24L14.45 14.05H17.2ZM8 15.05L8.3 16.8L-1.3 24H-4L8 15.05ZM28 0V0.15L15.55 9.55L15.65 7.35L25.5 0H28ZM-4 0L7.95 8.8H4.95L-4 2.1V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05 0V24H16.05V0H8.05ZM-4 8V16H28V8H-4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 9.65V14.45H28V9.65H-4ZM9.65 0V24H14.45V0H9.65Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6479_15659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketLoginSelectorUk);
export default __webpack_public_path__ + "static/media/market_login_selector_uk.3bfe931ba5b1851340880b9adfff0acc.svg";
export { ForwardRef as ReactComponent };